module.exports = __webpack_public_path__ + "img/code_img2.77383923.png";